module.exports = __webpack_public_path__ + "img/mini-blog-1.bee6915f.png";